import React from 'react'

const notFound = () => {
    return (
        <div className='d-flex justify-content-center align-items-center w-100' style={{ height: '100svh' }}>
            <div className='text-center'>
                <h1>!Oops page not found</h1>
                <a className='border-0 bg-transparent' href='https://maniskitchen-v1.netlify.app/' >⬅️ back to Home</a>
            </div>
        </div>
    )
}

export default notFound